import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MsComplexComponent } from './ms-complex.component';
import { ComplexElementComponent } from './complex-element/complex-element.component';
import { FormelementsModule } from 'ms-formelements';
import { MsHtmlcommandbuttonModule } from 'ms-htmlcommandbutton';
import { MsHtmloutputlabelModule } from 'ms-htmloutputlabel';
import { MsDatepickerModule } from 'ms-datepicker';
import { MsCheckboxModule } from 'ms-checkbox';
import { MsHtmlselectonemenuModule } from 'ms-htmlselectonemenu';
//import { HtmlCommandLinkModule } from 'html-command-link';
import { MsHtmlinputtextModule } from 'ms-htmlinputtext';
import { MsHtmloutputtextModule } from 'ms-htmloutputtext';
import { RadioButtonModule } from 'radio-button';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    FormelementsModule,
    MsHtmlcommandbuttonModule,
    MsHtmloutputlabelModule,
    MsDatepickerModule,
    MsCheckboxModule,
    MsHtmlselectonemenuModule,
    //HtmlCommandLinkModule,
    MsHtmlinputtextModule,
    MsHtmloutputtextModule,
    RadioButtonModule

  ],
  declarations: [MsComplexComponent, ComplexElementComponent],
  exports: [MsComplexComponent,ComplexElementComponent]
})
export class MsComplexModule { }
